import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import SadIcon from '../../components/Icon/SadIcon.jsx';
import { KOBOO_BLUE } from '../../constants/colors';
import defaultStyle from '../../constants/stylesDefault';
import SmallPaper from '../../components/Layout/SmallPaper';

const styles = () => ({
  ...defaultStyle,
  icon: {
    color: KOBOO_BLUE,
    width: '5em',
    height: 'auto',
    marginTop: '3vh',
  },
});

const NotFoundPage = props => (
    <SmallPaper>
        <div className={props.classes.center}>
            <SadIcon className={props.classes.icon}/>
            <h1>Oups, Erreur 404</h1>
            <Typography variant="h5" gutterBottom>Ce chemin ne mène nulle part</Typography>
        </div>
    </SmallPaper>
);

NotFoundPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotFoundPage);



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage/NotFoundPage.jsx